import {PrepareBlock} from '../core';

export interface ITransactionEmit extends PrepareBlock {

}